__turbopack_context__.v({
  "camera": "PostImage-module__DiS-OG__camera",
  "captionText": "PostImage-module__DiS-OG__captionText",
  "credit": "PostImage-module__DiS-OG__credit",
  "imagePart": "PostImage-module__DiS-OG__imagePart",
  "postImg": "PostImage-module__DiS-OG__postImg",
});
